import type { OrderData, OrderLineItemData } from "~/domains/orders/types/modelsV2";
import OrderLineListRow from "./OrderLineListRow";
import { Stack } from "~/common/mui";
import { CreateCaseSource } from "../orderDetails/components/ServiceCases/types";

interface Props {
  data: OrderLineItemData[];
  orderData: OrderData;
  soNumber?: string;
  poNumber?: string;
  selectable?: boolean;
  selectionDisabled?: boolean;
  selectedIndexes?: number[];
  selectItem?: (itemIndex: number) => void;
  selectableIndexes?: number[];
  selectableIndexSet?: Set<number>;
}
export const OrderLineList = ({
  data,
  orderData,
  soNumber,
  poNumber,
  selectable,
  selectionDisabled,
  selectedIndexes = [],
  selectItem,
  selectableIndexSet,
}: Props) => {
  return (
    <Stack gap={2}>
      {data.map((entry, index) => (
        <OrderLineListRow
          data={entry}
          key={index}
          lineItemIndex={index}
          orderData={orderData}
          soNumber={soNumber}
          poNumber={poNumber}
          selectable={selectable}
          selectionDisabled={selectionDisabled}
          selected={selectedIndexes.includes(index)}
          selectItem={selectItem}
          selectableIndexSet={selectableIndexSet}
          source={CreateCaseSource.LIST_PAGE}
        />
      ))}
    </Stack>
  );
};
